import React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { circularProgressClasses } from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import "./progressiveloader.scss";
import { pageLocale } from "../../utlis/locale";

const ProgressiveLoader = (props) => {
  const { loader } = props;
  const logoutText = sessionStorage.getItem("logout");
  const { please_wait } = pageLocale("common");

  return (
    <Backdrop
      sx={{
        color: "#fff",
        // zIndex: (theme) => theme.zIndex.drawer + 1,
        zIndex: 500,
      }}
      open={loader}
    >
      <Box sx={{ position: "relative" }} className="loader-box">
        <div>
          <svg viewBox="0 0 300 87">
            <defs>
              <linearGradient
                gradientUnits="userSpaceOnUse"
                id="my_gradient"
                x1="57.887"
                y1="8.45958"
                x2="80.687"
                y2="27.9637"
              >
                <stop className="stop-svg" />
                <stop offset="3" stopColor="white" />
              </linearGradient>
            </defs>
          </svg>
        </div>
        <CircularProgress
          className="circular-first"
          variant="determinate"
          sx={{
            color: (theme) =>
              theme.palette.grey[theme.palette.mode === "light" ? 100 : 500],
          }}
          size={80}
          thickness={4}
          {...props}
          value={100}
        />
        <CircularProgress
          variant="indeterminate"
          disableShrink
          sx={
            ({
              animationDuration: "600ms",
              position: "absolute",
              left: 0,
              [`& .${circularProgressClasses.circle}`]: {
                strokeLinecap: "round",
              },
            },
            { "svg circle": { stroke: "url(#my_gradient)" } })
          }
          size={80}
          thickness={4}
          {...props}
        />
        {logoutText ? (
          <Typography className="loader-text">Logging Out..</Typography>
        ) : (
          <Typography className="loader-text">{please_wait}</Typography>
        )}
      </Box>
    </Backdrop>
  );
};

export default ProgressiveLoader;
